import type { AuthUser } from '@/lib/api';
import { canEdit } from '@/lib/api';
import {
  MagicLinksSection,
  PushSubscribersSection,
} from '@/components/SelfReportAdmin';
import { RosterTabs } from './Roster';

export default function PlayerAccess({ user }: { user: AuthUser }) {
  const editable = canEdit(user.role);
  return (
    <div className="space-y-4">
      <RosterTabs />
      <header>
        <h1 className="text-xl font-semibold">Player access</h1>
        <p className="text-sm text-slate-400">
          Manage each player's magic link (hub URL, copy / rotate / revoke)
          and send them push notifications.
        </p>
      </header>
      {!editable ? (
        <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-6 text-sm text-slate-400">
          R4/R5 required.
        </div>
      ) : (
        <>
          <MagicLinksSection />
          <PushSubscribersSection />
        </>
      )}
    </div>
  );
}
